module.exports = __webpack_public_path__ + "img/customized-logistics.e8a47503.jpg";